import { initPostHog } from "@/analytics/posthog";
import { mountLandingPage } from "@site/mountLandingPage";
import { isStagingDeploy } from "@/shared/deployTarget";

function initLandingPage(): void {
  initPostHog();
  if (isStagingDeploy()) {
    document.body.classList.add("staging-deploy");
  }
  mountLandingPage();
}

initLandingPage();
